import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import useAppState from "../../context/AppContext";
import { IInfoStep } from "../../context/model";
import { isDisabledStep } from "../../utils/dataUtils";
import MgpTooltip from "../../elements/MgpTooltip/MgpTooltip";
import { handleKeyDown } from "../../utils/utils";

interface MgpRetirementProgressbarWithStepsProps {

}

export default function MgpRetirementProgressbarWithSteps({ ...props}: MgpRetirementProgressbarWithStepsProps) {
  const {
    state: {infoSteps, proposition},
  } = useAppState();

  const currentLocation = useLocation();
  const navigate = useNavigate();

  const isActiveStep = (step: IInfoStep) => {
    const currentIndex = infoSteps.findIndex(s => s.path === currentLocation.pathname);
    const index = infoSteps.findIndex(s => s.path === step?.path);
   
    if (index === currentIndex) {
      return 'active';
    } else if (index > currentIndex) {
      return "incomplete";
    } else {
      return "completed";
    }
  }

  const getStateCategory = (category: 'SITUATION' | 'BESOIN' | 'INFO' | 'GUARANTY') => {
    const firstStep = infoSteps.filter(step => step.category === category)[0];
    return isActiveStep(firstStep) === 'incomplete' ? 'incomplete' : 'completed';
  }

  const handleChangeStep = (step: IInfoStep) => {
    if (!isDisabledStep(proposition!,step)) {
      navigate({
        pathname: step.path,
        search: createSearchParams({
            id: proposition!.propositionId
        }).toString(),
      });
    }
  }

  const isLastStep = (step: IInfoStep) => {
    const steps = infoSteps.filter(el => el.category === "INFO" && !el.menuHide);
    const index = steps.findIndex(el => el.path === step.path);
    if (step.category === "INFO") {
      if (index === steps.length - 1) {
        return true;
      }
    }
    return false;
  }

    return (
      <div className="stepper-wrapper">
        <div className={`stepper-item ${getStateCategory("SITUATION")} mt-xs`}>
          <div className="step-counter">1</div>
          <div className="step-name fz-sm"> Je renseigne ma situation </div>
        </div>

        {
          infoSteps.filter(s => s.category === "SITUATION").map(subStep => <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }

        <div className={`stepper-item ${getStateCategory("BESOIN")} mt-xs`}>
          <div className="step-counter">2</div>
          <div className="step-name fz-sm">Je définis mes&nbsp;besoins</div>
        </div>
      

        {
          infoSteps.filter(s => s.category === "BESOIN").map(subStep => <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }
        
        <div className={`stepper-item ${getStateCategory("GUARANTY")} mt-xs`}>
          <div className="step-counter">3</div>
          <div className="step-name fz-sm">Je choisis ma&nbsp;couverture</div>
        </div>
        
        {
          infoSteps.filter(s => s.category === "GUARANTY").map(subStep =>  <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }
        
        <div className={`${getStateCategory("INFO")} mt-xs last-step-item`}>
          <div className="step-counter">4</div>
          <div className="step-name fz-sm">J'adhère</div>
        </div>

        {/* {
          infoSteps.filter(s => s.category === "INFO").map(subStep => <div key={subStep.code} className={`${isLastStep(subStep) ? `last-step-item` : 'stepper-item'} ${isActiveStep(subStep)}`} style={subStep.menuHide ? {display: "none"}: {}}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        } */}
        
      </div>
    );
 
} 